module.exports = __webpack_public_path__ + "media/images/championship__iconDown-e06a0caa673c85eaa03a0557a89cf9ef.png";